export default "__VITE_ASSET__57d30f08__"